module.exports = __webpack_public_path__ + "img/auditing.de5608be.webp";